import L from 'leaflet';
import { isEmpty, forEach } from 'lodash';

import * as annotationOps from '../../api/Annotations/annotation-operations';
import * as templateOps from '../../api/AnnotationTemplates/annotation-template-operations';

const Z_INDEX = 2000;

/**
 * Draws the video annotations in the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object[]} arg.annotations - The video annotations.
 * @param {?object} arg.annotationsLayer - The geoJSON layer where the annotations will be painted.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @param {Function}  [arg.onClickFunction] - Function for click on annotation event.
 * @returns {object} The leaflet layer where the annotations are painted.
 */
const drawVideoAnnotations = ({
  leafletMap,
  annotations,
  annotationsLayer,
  isUpdate = false,
  onClickFunction = () => {}
}) => {
  let newAnnotationsLayerContainer = '';

  if (!isUpdate) {
    newAnnotationsLayerContainer = L.geoJSON().addTo(leafletMap);
  } else {
    newAnnotationsLayerContainer = annotationsLayer;
    newAnnotationsLayerContainer.clearLayers();
  }

  if (!isEmpty(annotations)) {
    forEach(annotations, annotation => {
      const myAnnotationsLayer = L.geoJSON(annotationOps.getGeoJSON(annotation));
      newAnnotationsLayerContainer.addLayer(
        myAnnotationsLayer
          .getLayers()[0]
          .setZIndexOffset(Z_INDEX)
          .on('click', () => onClickFunction(annotation))
          .bindPopup(templateOps.getName(annotationOps.getTemplate(annotation)))
      );
    });
  }
  return newAnnotationsLayerContainer;
};
export default drawVideoAnnotations;
